

























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import Prism from "vue-prism-component";
import { required, url } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import { WebhookItem } from "@/modules/webhooks/types";
import { webhooks } from "@/modules/webhooks/utils";

const Webhooks = namespace("webhooks");
@Component({
  components: {
    prism: Prism,
  },
})
export default class CreateWebhook extends Vue {
  @Webhooks.Action("createWebhook") createWebhook!: (
    payload?: WebhookItem
  ) => Promise<{}>;
  @Webhooks.Action("fetchWebhooks") fetchWebhooks!: () => Promise<{}>;

  selectedWebhook = webhooks[0];

  code() {
    return `
{
    event: ${this.removeSpaces(this.selectedWebhook.label)},
    secret:"secrettt",
    applicantId:"08d8cd73-df3c-413d-8505-4a9fcb7cb2b2",
    status:"processed"
}
    `;
  }

  webhookForm = {
    name: "",
    url: "",
    endpoint: "",
    description: "",
  };

  hooks = webhooks;

  loading = false;
  hasErrors = false;
  isProcessedHookSelected = true;
  isReviewedHookSelected = false;

  goBack() {
    this.$router.push({ name: "webhooks" });
  }
  removeSpaces = (string) => string.replace(/\s/g, "");

  toggleProcessed() {
    this.isProcessedHookSelected = !this.isProcessedHookSelected;
    this.isReviewedHookSelected = false;
  }
  toggleReviewed() {
    this.isReviewedHookSelected = !this.isReviewedHookSelected;
    this.isProcessedHookSelected = false;
  }
  submitWebhook() {
    this.loading = true;

    this.createWebhook({
      event: this.selectedWebhook.value,
      name: this.webhookForm.name,
      url: this.webhookForm.endpoint,
      description: this.webhookForm.description,
      enabled: true,
      secret: "secretttt",
    })
      .then(() => {
        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Webhook created successfully.",
        });
        //Refetch webhook entries
        this.fetchWebhooks();
        this.goBack();
      })
      .catch(() => {
        this.hasErrors = true;
        this.loading = false;
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to create webhook.",
        });
      });
  }
  validations() {
    return {
      webhookForm: {
        endpoint: {
          required,
          url,
        },
        name: {
          required,
        },
        description: {
          required,
        }
      },
    };
  }
}
